import React from 'react';

// overriden in productization
export const Navbar = () => (<></>);
